import React from "react";
import { useTranslation } from "../i18n/I18nProvider";

type GenderValue = "M" | "F" | "X" | "";

interface GenderCardsProps {
  id: string;
  value: GenderValue;
  onChange: (value: "M" | "F") => void;
}

const FemaleIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="9" r="5" />
    <path d="M12 14v8M9 19h6" />
  </svg>
);

const MaleIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="10" cy="14" r="5" />
    <path d="M14 10l6-6M15 4h5v5" />
  </svg>
);

export const GenderCards: React.FC<GenderCardsProps> = ({ id, value, onChange }) => {
  const { t } = useTranslation();
  const options = [
    { value: "F" as const, label: t("wizard.primary.gender.options.f") || "Femenino", icon: <FemaleIcon /> },
    { value: "M" as const, label: t("wizard.primary.gender.options.m") || "Masculino", icon: <MaleIcon /> },
  ];

  return (
    <div className="gender-cards" role="radiogroup" id={id}>
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`gender-card${selected ? " is-selected" : ""}`}
            onClick={() => onChange(option.value)}
          >
            <span className="gender-card-icon">{option.icon}</span>
            <span className="gender-card-label">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};
